
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    prevComponent: { type: String, default: null },
    nextComponent: { type: String, default: null },
  },

  computed: {
    style() {
      const style = 'container-pb container-px inner-px sidebar:px-0'

      if (
        this.prevComponent === 'general_text' &&
        this.nextComponent === 'general_text'
      ) {
        return 'container-px inner-px sidebar:px-0 -mt-10'
      }

      if (this.prevComponent === 'general_text') {
        return style + ' -mt-10'
      }

      if (this.nextComponent === 'general_text') {
        return 'container-px inner-px sidebar:px-0'
      }

      return 'container-pb container-px inner-px sidebar:px-0'
    },
  },
}
